import type { Authenticator } from "@firecms/core";
import { type User } from "firebase/auth";
import { getMyPermissions } from "../firebase/getMyPermissions";
import type { AuthExtras } from "../types/auth";

const emptyExtras: AuthExtras = {
  isSuperManager: false,
  isAccountManager: false,
  isEventManager: false,
};

export const authenticator: Authenticator<User> = async ({
  user,
  authController,
}) => {
  if (user === null) {
    return true;
  }

  let extras: AuthExtras = emptyExtras;
  try {
    extras = await getMyPermissions();
  } catch (error) {
    console.warn("getMyPermissions failed", error);
    if (user.email) {
      extras = { ...emptyExtras, user: { email: user.email } };
    }
  }

  authController.setExtra(extras);
  return true;
};
